import { withFormik } from "formik";
import * as Yup from "yup";
const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/svg",
  "image/gif"
];
const formikEnhancer = withFormik({
  validationSchema: props =>
    Yup.object().shape({
      name: Yup.string().required("Please Enter Name"),
      username: Yup.string().required("Please Enter User Name"),
      password: Yup.string()
        .min(8, "Password must be atleast 8 characters.")
        .required("Please Enter Password"),
      file_image: Yup.mixed()
        .test("required", "Please upload a image", function(value) {
          // Only required if not editing
          if (!props.isEdit) {
            return value && value.name;
          }
          // In edit mode, allow existing image (string or file)
          return !!value;
        })
        .test(
          "fileFormat",
          "Only JPG, JPEG, PNG, SVG and GIF files are allowed.",
          value =>
            !value ||
            typeof value === "string" ||
            SUPPORTED_FORMATS.includes(value?.type)
        ),
      image_galary: Yup.array()
        .test(
          "required",
          "Please upload at least one image for gallery",
          function(value) {
            // Only required if not editing
            if (!props.isEdit) {
              return value && value.length > 0;
            }
            // In edit mode, allow existing images
            return value && value.length >= 0;
          }
        )
        .max(10, "You can upload a maximum of 10 images")
        .test(
          "fileFormat",
          "Only JPG, JPEG, PNG, SVG and GIF files are allowed.",
          value =>
            !value ||
            value.length === 0 ||
            value.every(
              file =>
                typeof file === "string" ||
                (file && SUPPORTED_FORMATS.includes(file.type))
            )
        ),
      staff_data: Yup.array().min(1, "Please select staff"),
      service_data: Yup.array().min(1, "Please select service"),
      venue_data: Yup.string().required("Please select venue data"),
      status: Yup.string().required("Please select status")
    }),
  mapPropsToValues: props => ({
    name: "",
    username: "",
    password: "",
    file_image: "",
    image_galary: [],
    staff_data: [],
    service_data: [],
    venue_data: "",
    status: true
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
